module.exports = {
	"amazon": "Glyph-amazon",
	"android": "Glyph-android",
	"announcement-preview-eye-filled": "Glyph-announcement-preview-eye-filled",
	"announcement-preview-eye-outlined": "Glyph-announcement-preview-eye-outlined",
	"announcement": "Glyph-announcement",
	"apple": "Glyph-apple",
	"arrow-down": "Glyph-arrow-down",
	"arrow-left": "Glyph-arrow-left",
	"arrow-right": "Glyph-arrow-right",
	"arrow-up": "Glyph-arrow-up",
	"audio-level-1": "Glyph-audio-level-1",
	"audio-level-2": "Glyph-audio-level-2",
	"audio-level-3": "Glyph-audio-level-3",
	"audio-level-mute": "Glyph-audio-level-mute",
	"avatar-add": "Glyph-avatar-add",
	"avatar-circle": "Glyph-avatar-circle",
	"avatar-group-fill": "Glyph-avatar-group-fill",
	"avatar-group-stroke": "Glyph-avatar-group-stroke",
	"avatar-hexagon-fill": "Glyph-avatar-hexagon-fill",
	"avatar-remove": "Glyph-avatar-remove",
	"avatar": "Glyph-avatar",
	"bar-graph-fill": "Glyph-bar-graph-fill",
	"bar-graph-stroke": "Glyph-bar-graph-stroke",
	"bell-fill": "Glyph-bell-fill",
	"bell-stroke": "Glyph-bell-stroke",
	"book": "Glyph-book",
	"calendar-fill": "Glyph-calendar-fill",
	"calendar-stroke": "Glyph-calendar-stroke",
	"calendar": "Glyph-calendar",
	"camcorder": "Glyph-camcorder",
	"camera": "Glyph-camera",
	"cart": "Glyph-cart",
	"caution": "Glyph-caution",
	"chat-add-bubble-fill": "Glyph-chat-add-bubble-fill",
	"chat-add-bubble": "Glyph-chat-add-bubble",
	"chat-check-bubble-fill": "Glyph-chat-check-bubble-fill",
	"chat-check-bubble": "Glyph-chat-check-bubble",
	"chat-close-bubble-fill": "Glyph-chat-close-bubble-fill",
	"chat-close-bubble": "Glyph-chat-close-bubble",
	"chat-mute": "Glyph-chat-mute",
	"chat-stroke": "Glyph-chat-stroke",
	"chat": "Glyph-chat",
	"check": "Glyph-check",
	"chevron-down": "Glyph-chevron-down",
	"chevron-left": "Glyph-chevron-left",
	"chevron-right": "Glyph-chevron-right",
	"chevron-up": "Glyph-chevron-up",
	"class-leave-stroke": "Glyph-class-leave-stroke",
	"classes": "Glyph-classes",
	"clock-bubble": "Glyph-clock-bubble",
	"clock": "Glyph-clock",
	"close-btn": "Glyph-close-btn",
	"close-circle": "Glyph-close-circle",
	"close": "Glyph-close",
	"credit-card": "Glyph-credit-card",
	"crown-stroke": "Glyph-crown-stroke",
	"crown": "Glyph-crown",
	"disabled": "Glyph-disabled",
	"display-board": "Glyph-display-board",
	"dollar-circle": "Glyph-dollar-circle",
	"dollar": "Glyph-dollar",
	"download": "Glyph-download",
	"ellipses": "Glyph-ellipses",
	"email-transcript": "Glyph-email-transcript",
	"email": "Glyph-email",
	"excel": "Glyph-excel",
	"explanation-circle": "Glyph-explanation-circle",
	"explanation": "Glyph-explanation",
	"eye": "Glyph-eye",
	"facebook": "Glyph-facebook",
	"flag": "Glyph-flag",
	"fullscreen": "Glyph-fullscreen",
	"gear": "Glyph-gear",
	"globe": "Glyph-globe",
	"google-plus": "Glyph-google-plus",
	"google": "Glyph-google",
	"heart-bubble": "Glyph-heart-bubble",
	"heart": "Glyph-heart",
	"help": "Glyph-help",
	"home": "Glyph-home",
	"image": "Glyph-image",
	"info-fill": "Glyph-info-fill",
	"info": "Glyph-info",
	"instagram": "Glyph-instagram",
	"ios": "Glyph-ios",
	"lightbulb": "Glyph-lightbulb",
	"link": "Glyph-link",
	"linkedin": "Glyph-linkedin",
	"location-pin": "Glyph-location-pin",
	"lock-stroke": "Glyph-lock-stroke",
	"lock": "Glyph-lock",
	"mail": "Glyph-mail",
	"megaphone": "Glyph-megaphone",
	"message-activity": "Glyph-message-activity",
	"message-bubble-fill": "Glyph-message-bubble-fill",
	"message-bubble-stroke": "Glyph-message-bubble-stroke",
	"message-group": "Glyph-message-group",
	"message-individual": "Glyph-message-individual",
	"message": "Glyph-message",
	"microphone": "Glyph-microphone",
	"minimize": "Glyph-minimize",
	"mobile": "Glyph-mobile",
	"nav-event": "Glyph-nav-event",
	"note": "Glyph-note",
	"paperclip": "Glyph-paperclip",
	"pause": "Glyph-pause",
	"pdf": "Glyph-pdf",
	"pencil-compose-stroke": "Glyph-pencil-compose-stroke",
	"pencil-stroke": "Glyph-pencil-stroke",
	"pencil": "Glyph-pencil",
	"pinterest": "Glyph-pinterest",
	"play": "Glyph-play",
	"plus-circle-fill": "Glyph-plus-circle-fill",
	"plus-circle-stroke": "Glyph-plus-circle-stroke",
	"plus": "Glyph-plus",
	"powerpoint": "Glyph-powerpoint",
	"printer": "Glyph-printer",
	"remind-icon": "Glyph-remind-icon",
	"schedule": "Glyph-schedule",
	"school-stroke": "Glyph-school-stroke",
	"school": "Glyph-school",
	"search": "Glyph-search",
	"share": "Glyph-share",
	"sign-out": "Glyph-sign-out",
	"sort": "Glyph-sort",
	"spreadsheet": "Glyph-spreadsheet",
	"stamp-check": "Glyph-stamp-check",
	"stamp-close": "Glyph-stamp-close",
	"stamp-help": "Glyph-stamp-help",
	"stamp-star": "Glyph-stamp-star",
	"star": "Glyph-star",
	"success-checkmark-stroke": "Glyph-success-checkmark-stroke",
	"text": "Glyph-text",
	"thumbtack": "Glyph-thumbtack",
	"trash": "Glyph-trash",
	"twitter": "Glyph-twitter",
	"upload": "Glyph-upload",
	"video": "Glyph-video",
	"vimeo": "Glyph-vimeo",
	"widgets": "Glyph-widgets",
	"word": "Glyph-word",
	"world": "Glyph-world",
	"youtube": "Glyph-youtube"
};


//////////////////
// WEBPACK FOOTER
// ./~/@remind/r101-glyphs/dist/glyphs.json
// module id = 1134
// module chunks = 4